/**
 * CSV セルをダブルクォートで囲み、内部の " を RFC 4180 どおり "" にエスケープする。
 * ヘッダー・データ行の両方で使う。
 */
export const quoteCsvField = (value: string | number): string => `"${String(value).replaceAll('"', '""')}"`;

/**
 * 事前質問文を CSV ヘッダー用に正規化する。
 *
 * JSON.stringify で囲むとヘッダーが `""質問""` になり、Excel が列を誤って結合して
 * 問いと回答がずれる。ダブルクォートはシングルクォートへ置換し、改行は除く。
 */
export const escapeCsvQuestionHeader = (value: string): string =>
	value.replaceAll(/\\"/g, '"').replaceAll(/"/g, "'").replaceAll(/[\n]/g, "");
